import * as React from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import theme from "../styles/theme";
import { CompetencyType } from "../types/Competency";
import Status from "../types/enum/Status";
import Button from "./Button";
import CompetencyNavigator from "./CompetencyNavigator";
import FlexBox, { FlexGrow } from "./FlexBox";
import FlexCard from "./FlexCard";
import Icon from "./Icon";
import SearchBox from "./SearchBox";
import SnackBar from "./SnackBar";
import OptionGroupModal from "./OptionGroupModal";
import axios from "axios";
import { VersionContext } from "../context/VersionContext";
import { UserContext } from "../context/UserContext";

type SearchCompetenciesProps = {
  totalRequiredCredits: number | null;
  totalCredits?: number | null;
  optionGroupCredits?: number | null | undefined;
  defaultSearchText?: string;
  navigationData?: Array<CompetencyType>;
  height?: string;
  showPillar?: boolean;
  onSearch: (searchKey: string) => void;
  mode: "view" | "edit";
  snackbarOpen: boolean;
  setSnackbarOpen: (x: boolean) => void;
  children?: React.ReactNode;
  resetSearch?: boolean;
  competencies?: any;
  competency?: any;
  showNavigator?: boolean;
};
const CustomGrow = styled(FlexGrow)`
  flex-grow: 0;
  width: 100%;
`;
interface State {
  searchTerm: string;
}

export default function SearchCompetencies({
  totalCredits,
  totalRequiredCredits,
  optionGroupCredits,
  defaultSearchText,
  navigationData,
  children,
  mode,
  height = "89px",
  onSearch,
  snackbarOpen,
  setSnackbarOpen,
  resetSearch,
  competencies,
  competency,
  showNavigator,
}: SearchCompetenciesProps): JSX.Element {

  const { identity_university } = useParams();

  const showPillar = !identity_university;
  const navigate = useNavigate();
  // const [values, setValues] = useState({});
  // const redirectToPillar = (mode: "view" | "edit") => {
  //   // localStorage.removeItem("competencies");
  //   navigate(`/view/pillars?mode=${mode}`);
  // };
  const [optionGroupOpen, setOptionGroupOpen] = useState<boolean>(false);
  const [optionGroups, setOptionGroups] = useState<any>([]);
  const { version } = React.useContext(VersionContext);
  const { isModified, setModified, isOpen, setOpen } =
    React.useContext(UserContext);

  const fetchOptionGroups = () => {
    axios
      .get(`/optiongroups?curriculum_version=${version.version_number}`)
      .then((res) => {
        if (res.data) {
          setOptionGroups(res.data.optionGroups);
        }
      })
      .catch(() => {});
  };

  React.useEffect(() => {
    fetchOptionGroups();
  }, []);
  const currentCompetency = competency?.competency_code || "";

  const getNextAndPreviousCompetencies = (
    competencies: any,
    currentCompetency: string
  ) => {
    const currentIndex = competencies?.findIndex(
      (comp: any) => comp?.competency_code === currentCompetency
    );
    if (currentIndex === -1) {
      return { nextCompetency: null, previousCompetency: null };
    }

    const currentPrefix = currentCompetency.substring(0, 3);

    const nextCompetency =
      currentIndex < competencies?.length - 1 &&
      competencies[currentIndex + 1].competency_code.substring(0, 3) ===
        currentPrefix
        ? competencies[currentIndex + 1].competency_code
        : null;

    const previousCompetency =
      currentIndex > 0 &&
      competencies[currentIndex - 1].competency_code.substring(0, 3) ===
        currentPrefix
        ? competencies[currentIndex - 1].competency_code
        : null;

    return { nextCompetency, previousCompetency };
  };

  const { nextCompetency, previousCompetency } = getNextAndPreviousCompetencies(
    competencies,
    currentCompetency
  );

  return (
    <>
      {optionGroupOpen && (
        <OptionGroupModal
          fetchOptionGroups={fetchOptionGroups}
          optionGroups={optionGroups}
          setOptionGroups={setOptionGroups}
          title="Option Groups"
          isOpen={optionGroupOpen}
          setOpen={setOptionGroupOpen}
        />
      )}
      <SnackBar
        isOpen={snackbarOpen}
        setOpen={setSnackbarOpen}
        type="error"
        header="Competency not found"
        message="Make sure the competency code entered is correct and try again or explore competencies using View Pillars control !"
      />
      <FlexCard
        // height={`calc(100vh - ${height})`}
        direction="column"
        alignItems="start"
        className="visible-scrollbar"
      >
        <CustomGrow
          style={{
            borderBottom: `1px solid ${theme.color.lightBlueGray100}`,
            position: "sticky",
            top: "0px",
            background: "white",
            zIndex: "1000",
          }}
        >
          <FlexBox alignItems="center">
            <FlexGrow
              style={{
                padding: "16px",
                display:
                  totalRequiredCredits || totalRequiredCredits === 0
                    ? "flex"
                    : "",
                alignItems: "center",
              }}
            >
              {navigationData && navigationData?.length > 0 ? (
                <div
                        onClick={() => {
                          window.location.pathname = "/version-competency";
                        }}
                        className="reduce_opct_onhover"
                        style={{
                          color: "rgb(38, 51, 212)",
                          alignItems: "center",
                          display: "flex",
                          gap: 10,
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        <Icon name={"arrow_back"}></Icon> Back to all competencies
                      </div>
                // <CompetencyNavigator path={navigationData} />
              ) : (
                <FlexBox
                  style={{
                    position: "relative",
                    justifyContent: "start",
                    flexWrap: "nowrap",
                    alignItems: 'start'
                  }}
                >
                  <SearchBox
                    resetSearch={resetSearch}
                    defaultKeyword={defaultSearchText}
                    label="Competency code"
                    onSearch={(keyword: string) => onSearch(keyword)}
                  />
                  {(totalRequiredCredits || totalRequiredCredits === 0) && (
                    <FlexBox
                    style={{
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      padding: "10px",
                      borderRadius: "5px",
                      color: "black",
                      background: "#fffce0f2",
                      alignItems: "start",
                      // position: "absolute",
                      minWidth: "250px",
                      left: "210px",
                      top: "0",
                      boxShadow: "0px 1px 5px #71717180",
                    }}
                    >
                      <div style={{ color: "#006804" }}>
                        <div style={{color: "#000000", marginBottom:5, fontWeight:"bold" }}>
                          Total credits for pillar
                          <span style={{ marginLeft: 5, fontWeight: "bold" }}>
                            {localStorage
                              .getItem("currentPillar")
                              ?.toUpperCase()}
                          </span>
                        </div>
                        <div style={{ fontWeight: "", color: "#026806" }}>
                          <div
                            style={{
                              display: "flex",
                              marginBottom: 5,
                              marginTop: 5,
                              borderBottom: "1px solid #ececec",
                            }}
                          >
                            <div style={{ width: 300 }}>
                              {" "}
                              All Competencies
                            </div>{" "}
                            :
                            <span style={{ marginLeft: 10 }}>
                              {totalCredits}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              marginBottom: 5,
                              borderBottom: "1px solid #ececec",
                            }}
                          >
                            <div style={{ width: 300 }}>
                              {" "}
                              Required individual competencies
                            </div>{" "}
                            :
                            <span style={{ marginLeft: 10 }}>
                              {totalRequiredCredits}
                            </span>
                          </div>
                          <div style={{ display: "flex", marginBottom: 5 }}>
                            <span style={{ width: 300 }}>
                              {" "}
                              Required from option groups
                            </span>{" "}
                            :
                            <span style={{ marginLeft: 10 }}>
                              {optionGroupCredits &&
                                Math.ceil(optionGroupCredits)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </FlexBox>
                  )}
                </FlexBox>
              )}

              {showNavigator && (
                <FlexBox
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    marginTop: 5,
                  }}
                >
                  <Button
                    className={previousCompetency && "reduce_opct_onhover"}
                    style={{
                      // boxShadow: "0 2px 5px #808080cc",
                      border: "1px solid #8f8fff",
                      minWidth: 120,
                    }}
                    onClick={() => {
                      if (isModified) {
                        setOpen(true);
                      } else {
                        navigate(`/modify/competency/${previousCompetency}`);
                      }
                    }}
                    status={Status.primary}
                    isOutline={true}
                    disabled={!previousCompetency}
                  >
                    <Icon
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      fixedWidth={false}
                      color="rgb(38, 51, 212)"
                      name={"navigate_before"}
                    />
                    <span style={{ color: "rgb(0 13 169)" }}>
                      {previousCompetency}
                    </span>
                  </Button>
                  {/* <span style={{color:'blue'}}>SEN-103 | AIC-301</span> */}
                  <Button
                    className={previousCompetency && "reduce_opct_onhover"}
                    style={{
                      // boxShadow: "0 2px 5px #808080cc",
                      border: "1px solid #8f8fff",
                      marginRight: 20,
                      minWidth: 120,
                    }}
                    onClick={() => {
                      if (isModified) {
                        setOpen(true);
                      } else {
                        navigate(`/modify/competency/${nextCompetency}`);
                      }
                    }}
                    status={Status.primary}
                    isOutline={true}
                    disabled={!nextCompetency}
                  >
                    <span style={{ color: "rgb(0 13 169)" }}>
                      {nextCompetency}
                    </span>
                    <Icon
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        // marginRight: 20,
                      }}
                      fixedWidth={false}
                      color="rgb(38, 51, 212)"
                      name={"navigate_next"}
                    />
                  </Button>
                </FlexBox>
              )}
            </FlexGrow>

            {showPillar && !navigationData && (
              <FlexBox style={{ textAlign: "end", paddingRight: 10 }}>
                <FlexBox
                  style={{
                    color: "black",
                    background: "",
                    padding: 5,
                    borderRadius: 5,
                  }}
                >
                  <Icon
                    style={{ paddingRight: 5 }}
                    color="orange"
                    fixedWidth={false}
                    name={"star"}
                  />
                  : Option group members
                </FlexBox>
                {/* <FlexGrow style={{ padding: "16px" }}>
                  <Button
                    className="reduce_opct_onhover"
                    style={{
                      background: theme.color.blueButton,
                      boxShadow: "0 2px 5px #808080cc",
                      border: "none",
                      // width: 120,
                    }}
                    onClick={() => {
                      redirectToPillar(mode);
                    }}
                    status={Status.primary}
                    isOutline={false}
                  >
                    <Icon
                      style={{ paddingRight: 5 }}
                      color="white"
                      fixedWidth={false}
                      name={"visibility"}
                    />{" "}
                    View Pillars
                  </Button>
                </FlexGrow> */}
              </FlexBox>
            )}

            {/* {identity_university && (
              <FlexBox>
                <FlexGrow style={{ padding: "16px" }}>
                  <Button
                    className="reduce_opct_onhover"
                    style={{
                      background: theme.color.blueButton,
                      boxShadow: "0 2px 5px #808080cc",
                      border: "none",
                      // width: 120,
                    }}
                    onClick={() => {
                      navigate("/version-competency");
                    }}
                    status={Status.primary}
                    isOutline={false}
                  >
                    <Icon
                      style={{ paddingRight: 5 }}
                      color="white"
                      fixedWidth={false}
                      name={"arrow_back"}
                    />{" "}
                    Back
                  </Button>
                </FlexGrow>
              </FlexBox>
            )} */}
          </FlexBox>
        </CustomGrow>
        <CustomGrow style={{ flexGrow: 1, flexBasis: "100%" }}>
          {children}
        </CustomGrow>
      </FlexCard>
    </>
  );
}
